import { Utils } from './../underscore-extensions';
import directives from './module';

directives.directive(
    'redirectToReact',
    () => (
        scope: ng.IScope,
        element: ng.IAugmentedJQuery,
        attrs: ng.IAttributes
    ) => {
        const [url, productName, params]: any = attrs.redirectToReact.split(
            ','
        );
        const href = Utils.getRedirectToReactUrl(url, productName, params);
        const handleClick = (event: Event) => {
            event.preventDefault();
            Utils.redirectToReact(url, productName, params);
        };
        element[0].addEventListener('click', handleClick);

        scope.$on('$destroy', () => {
            element[0].removeEventListener('click', handleClick);
        });

        element.attr('href', href);
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/redirectToReactDirective.ts